import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.16, 1, 0.3, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-warm-white/95 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-183">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-184">
        <div className="font-serif text-2xl font-bold text-espresso tracking-tight" data-id="element-185">
          Masa Pan<span className="text-terracotta" data-id="element-186">.</span>
        </div>
        <a href="#comprar" className="bg-espresso text-cream px-6 py-2.5 rounded-none font-medium text-sm tracking-wide hover:bg-terracotta transition-colors duration-300" data-id="element-187">
          Comprar ahora
        </a>
      </div>
    </motion.nav>;
}